import { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { client, urlFor } from '../lib/sanityClient'
import './blogListing.css';

const categoryLabels = {
  'safari-tips': 'Safari Tips',
  'wildlife': 'Wildlife',
  'tour-operations': 'Tour Operations',
  'technology': 'Technology',
  'news': 'News',
}

const Blog = () => {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    client.fetch(`*[_type == "post"] | order(publishedAt desc) {
      _id, title, slug, excerpt, publishedAt, coverImage, author, category
    }`)
      .then(data => { setPosts(data); setLoading(false) })
      .catch(() => setLoading(false))
  }, [])

  return (
    <div className="body-div">
      <section className="blog-hero">
        <div className="wrap">
          <p className="eyebrow">From the field</p>
          <h1>Notes on running a safari business.</h1>
          <p className="lede">
            Safari planning, wildlife, and the operational detail behind a good tour.
          </p>
        </div>
      </section>

      <section className="blog-list">
        <div className="wrap mt-5">
          {loading ? (
            <div className="blog-state">
              <div className="spinner" aria-hidden="true" />
              <span>Loading posts…</span>
            </div>
          ) : posts.length === 0 ? (
            <div className="blog-state">
              <p>No posts published yet. Check back soon.</p>
            </div>
          ) : (
            <div className="blog-grid">
              {posts.map((post) => (
                <article key={post._id} className="blog-card">
                  <div className="blog-card-media">
                    {post.coverImage ? (
                      <img
                        src={urlFor(post.coverImage).width(600).height(340).fit('crop').url()}
                        alt={post.title}
                      />
                    ) : (
                      <div className="blog-card-fallback">
                        <span>Twigaa.ai</span>
                      </div>
                    )}
                  </div>

                  <div className="blog-card-body">
                    {post.category && (
                      <span className="blog-badge">
                        {categoryLabels[post.category] || post.category}
                      </span>
                    )}

                    <h3 className="blog-card-title">{post.title}</h3>

                    {post.excerpt && (
                      <p className="blog-card-excerpt">
                        {post.excerpt.length > 120 ? `${post.excerpt.slice(0, 120)}…` : post.excerpt}
                      </p>
                    )}

                    <div className="blog-card-foot">
                      <small className="blog-meta">
                        {post.author && <span>{post.author} · </span>}
                        {post.publishedAt &&
                          new Date(post.publishedAt).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric',
                          })}
                      </small>
                      <Link to={`/blog/${post.slug.current}`} className="btn btn-ghost blog-read-more">
                        Read more →
                      </Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export default Blog
